import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "crm:flex crm:items-center crm:max-w-full" }
const _hoisted_2 = {
  key: 0,
  class: "crm:max-w-[calc(100%-36px)]"
}
const _hoisted_3 = { class: "crm:text-left" }
const _hoisted_4 = ["onMouseenter", "onMouseleave"]
const _hoisted_5 = { class: "crm:flex crm:flex-col" }
const _hoisted_6 = { class: "crm:flex crm:flex-col crm:text-center crm:my-2" }
const _hoisted_7 = { class: "crm:inline-block crm:w-full crm:text-center my-2" }
const _hoisted_8 = { class: "crm:text-primary! crm:text-lg! crm:font-extrabold!" }
const _hoisted_9 = {
  key: 0,
  class: "crm:flex crm:flex-col crm:text-center crm:my-2"
}
const _hoisted_10 = { class: "crm:inline-block crm:w-full crm:text-center crm:cursor-pointer" }

import {inject, ref} from 'vue';
import BaseAlertify from "fallco-frontend-framework/src/vue/plugins/BaseAlertify/BaseAlertify.vue";
import BasePopover from '../components/BasePopover.vue'
import {interface_user, man, logout} from '../svg/svgs.js'


export default {
  __name: 'AppUserProfilePopover',
  props: {
  is_sidebar_open: {
    type: Boolean,
    default: false
  },
  datiUtente: {
    type: Object,
    default() {
      return {}
    }
  }
},
  setup(__props) {

/**
 * @doc Renderizza un popover contenente le informazioni dell'utente connesso
 */
const props = __props

const is_user_popover = ref(false)

/**
 * @inject {isMobile} recupera il valore se siamo nella modalità mobile oppure no
 */
const isMobile = inject('isMobile');

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

/**
 * @inject {$AxiosClient} recupera la libreria per le chiamate ajax
 */
const $AxiosClient = inject('$AxiosClient');


const isAlertifyLogOut = ref(false)
async function logOut() {
    isAlertifyLogOut.value = false;
    const sendLogout = await $AxiosClient.post('Login', 'logout', null, {messages: 'error'})
    if(sendLogout.esito === 'ok') {
      if (datiUtente.is_cittadino) {
        window.location = './login_clienti'
      } else if (datiUtente.is_notaio) {
        window.location = './login'
      }
    }
}

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_tooltip = _resolveComponent("base-tooltip")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BaseAlertify, {
      "is-toggle": isAlertifyLogOut.value,
      "onUpdate:isToggle": _cache[0] || (_cache[0] = $event => ((isAlertifyLogOut).value = $event)),
      "onExe:callback": logOut
    }, {
      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("p", null, "Sicuro di voler uscire dall'applicazione ?", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-toggle"]),
    _createElementVNode("section", {
      class: _normalizeClass(["crm:border-t-0 crm:border-r-0 crm:border-l-0 crm:lg:px-4", [!__props.is_sidebar_open ? 'crm:justify-center crm:flex' : '']])
    }, [
      _createVNode(BasePopover, {
        value: is_user_popover.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => ((is_user_popover).value = $event)),
        "custom-classes": {
              link: 'crm:shadow-none! crm:p-0!',
              container: !_unref(isMobile) ? 'crm:flex crm:flex-col crm:right-auto crm:left-52 crm:-top-32 crm:w-96!' : 'crm:flex crm:flex-col'
            }
      }, {
        cta: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_icon, {
              icon: _unref(interface_user),
              class: _normalizeClass({'crm:mr-4 crm:min-w-[20px]': !_unref(isMobile) && __props.is_sidebar_open}),
              sizing: {width: _unref(isMobile) ? '25px' : '20px', height: _unref(isMobile) ? '25px' : '20px'}
            }, null, 8 /* PROPS */, ["icon", "class", "sizing"]),
            (__props.is_sidebar_open && !_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createTextVNode(" Il tuo account ", -1 /* CACHED */)),
                    _createVNode(_component_base_tooltip, {
                      "tooltip-message": __props.datiUtente.nome_utente
                    }, {
                      default: _withCtx(({mouseEventEnter, mouseEventLeave}) => [
                        (__props.datiUtente.is_cittadino)
                          ? (_openBlock(), _createElementBlock("small", {
                              key: 0,
                              class: "crm:truncate crm:block",
                              onMouseenter: mouseEventEnter,
                              onMouseleave: mouseEventLeave
                            }, _toDisplayString(__props.datiUtente.nome_utente), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_4))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip-message"])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("section", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, [
                _createVNode(_component_base_icon, { icon: _unref(man) }, null, 8 /* PROPS */, ["icon"])
              ]),
              _createElementVNode("h2", _hoisted_8, _toDisplayString(__props.datiUtente.nome_utente), 1 /* TEXT */)
            ]),
            (!__props.datiUtente.is_cittadino)
              ? (_openBlock(), _createElementBlock("section", _hoisted_9, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("a", {
                    href: "cambio_password",
                    class: "crm:underline! crm:text-primary! crm:cursor-pointer crm:inline-block crm:mb-2"
                  }, "Cambia Password", -1 /* CACHED */),
                  _createElementVNode("a", {
                    href: "privacy",
                    class: "crm:underline! crm:text-primary! crm:cursor-pointer crm:inline-block crm:mb-2"
                  }, "Informativa Privacy", -1 /* CACHED */)
                ]))]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (isAlertifyLogOut.value = true), ["prevent"]))
          }, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_base_icon, {
                icon: _unref(logout),
                stroke: _unref($DesignSystem).design_colors.primary
              }, null, 8 /* PROPS */, ["icon", "stroke"])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "crm:underline! crm:text-primary! crm:inline-block crm:w-full crm:text-center crm:cursor-pointer" }, "Effettua il logout", -1 /* CACHED */))
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["value", "custom-classes"])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}